import React from 'react';
import { Form, Field } from 'react-final-form';
import css from './SearchBar.module.css';

function SearchBar({ onSubmit }) {
  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={css.heroSearchWrapper}>
          <div className={css.searchInput}>
            <Field name="keywords">
              {({ input }) => (
                <input
                  {...input}
                  type="text"
                  placeholder="Search Experiences"
                  id="keywords"
                />
              )}
            </Field>
          </div>
          <button type="submit" className={css.searchButton}>
            Search
          </button>
        </form>
      )}
    />
  );
}

export default SearchBar;